/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Practice_Which_SkillInputs */



/**
* | output |
* | --- |
* | "Which skill can I practise?" |
*
* @param {Chat_Quick_Practice_Which_SkillInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_practice_which_skill = /** @type {((inputs?: Chat_Quick_Practice_Which_SkillInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Practice_Which_SkillInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Welke vaardigheid kan ik oefenen?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quelle compétence puis-je pratiquer ?")
	return /** @type {LocalizedString} */ ("Which skill can I practise?")
});